import React from "react";

export default function AprilFoolDay4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-apr41{fill:#b01e68}.cls-apr42{fill:#fff}.cls-apr43{fill:#8e0c53}.cls-apr44{fill:#dc3535}.cls-apr45{fill:#f49d1a}"
            }
          </style>
        </defs>
        <path
          d="M1596.41 1717.62h-50.33v-31h50.51l.1 31h-.28Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0H740.8v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-102.78-1.21c-19.04-2.7-37.4-10.05-53.09-21.23l17.99-25.25c11.67 8.32 25.31 13.77 39.46 15.78l-4.36 30.69Zm1265.79-12.36-14.29-27.51c12.7-6.59 23.8-16.26 32.1-27.95l25.27 17.95c-11.14 15.69-26.04 28.66-43.09 37.51Zm-1356.33-52.02c-8.81-17.04-13.47-36.24-13.48-55.54l31-.02c0 14.58 3.38 28.48 10.02 41.32l-27.54 14.24Zm1420.57-38.62-30.7-4.31c.58-4.17.88-8.43.88-12.68v-35.44h31v35.44c0 5.68-.4 11.4-1.18 16.99Zm-1403.05-67.26h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33Zm-1404.23-65.16h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33Zm-1404.23-65.16h-31v-50.33h31v50.33Zm1404.23-35.5h-31V1259h31v50.33Zm-1404.23-65.16h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33Zm-1404.23-65.16h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33Zm-1404.23-65.16h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33ZM313.35 942.19h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33ZM313.35 841.53h-31V791.2h31v50.33Zm1404.23-35.5h-31V755.7h31v50.33ZM313.35 740.87h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33ZM313.35 640.21h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33ZM313.35 539.55h-31v-50.33h31v50.33Zm1404.23-35.5h-31v-50.33h31v50.33ZM313.35 438.89h-31v-35.33c0-5.73.4-11.48 1.2-17.12l30.69 4.34c-.59 4.2-.9 8.5-.9 12.77v35.33Zm1373.23-35.48c-.02-14.57-3.41-28.47-10.07-41.31l27.52-14.27c8.83 17.03 13.51 36.23 13.54 55.53l-31 .05ZM330.01 351.32l-25.25-17.98c11.16-15.68 26.08-28.63 43.13-37.47l14.26 27.53c-12.7 6.58-23.81 16.23-32.13 27.92Zm1318.57-21.33c-11.68-8.3-25.33-13.75-39.48-15.74l4.33-30.7c19.04 2.68 37.41 10.01 53.11 21.17l-17.96 25.26Zm-87.59-16.63h-50.33v-31h50.33v31Zm-100.66 0H1410v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0H906.7v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0h-50.33v-31h50.33v31Zm-100.66 0H403.4v-31h50.33v31Z"
          className="cls-apr45"
        />
        <path
          d="M1338.11 1779.11c-7.15 0-15.03-1.57-22.51-6.31-11.13-7.06-18.02-19.08-19.83-34.34-14.29-4.21-25.84-12.57-33.65-24.43-4.29-6.52-6.95-13.26-8.35-19.96-5.11-1.23-10.17-3.44-15.01-6.96-17.93-13.07-24.85-38.83-17.21-64.1 1.36-4.49 6.1-7.04 10.59-5.68 4.49 1.36 7.04 6.1 5.68 10.59-5.46 18.08-.96 36.77 10.95 45.45 1.29.94 2.63 1.73 4 2.38 1.49-16.75 9-31.73 15.59-40.58 9.62-12.91 33.85-34.98 56.73-26.12 9.44 3.65 16.89 11.98 19 21.21 6.16 27.03-33.02 49.29-37.51 51.74-6.79 3.71-20.13 10.98-35.01 12.86 1.09 3.33 2.64 6.62 4.75 9.82 5.17 7.85 12.17 12.92 19.78 15.96 3.79-22.49 20.17-41.43 34.48-51.61 14.73-10.48 29.68-14.21 41.01-10.24 7.9 2.77 14.41 9.43 16.97 17.38 7.11 22.05-17.67 50.62-43.74 60.48-9.6 3.63-20.56 5.26-31.27 4.75 1.5 6.28 4.66 12.92 11.15 17.04 13.36 8.47 30.47-.26 30.64-.35 4.16-2.17 9.3-.56 11.47 3.6s.58 9.28-3.58 11.46c-.69.36-11.61 5.96-25.13 5.96Zm-25.36-54.8c9.82.67 19.29-.99 26.06-3.55 20.85-7.89 36.85-29.21 33.57-39.36-.94-2.9-3.52-5.54-6.42-6.56-5.79-2.03-15.8 1.13-25.53 8.05-12.55 8.93-25.18 24.68-27.69 41.42Zm1.43-100.26c-11.11 0-25.14 11.82-32.18 21.28-5.31 7.13-11.46 19.33-12.4 32.65 11.51-1.44 22.71-7.55 28.84-10.9 13.52-7.38 31.48-22.5 29.08-33.04-1-4.39-5.14-7.82-8.56-9.14-1.5-.58-3.1-.85-4.77-.85Z"
          className="cls-apr41"
        />
        <path
          d="M372.92 923.15c-2.46 0-4.89-1.06-6.58-3.11a8.502 8.502 0 0 1 1.17-11.96c.63-.52 14.28-12.15 10.52-29.97-1.67-7.9-6.45-15.28-13.79-21.5-3.28 10.64-8.62 20.1-15.18 27.27-11.52 12.59-29.75 21.04-46.43 21.54-11.41.33-21.04-2.98-27.87-9.6-6.34-6.15-10.28-15.28-10.28-23.84 0-12.99 8.73-25.64 23.94-34.7 14.95-8.9 39.1-15.3 62.43-7.55-.49-9.16-3.19-18.81-9.23-28.19-2.64-4.1-5.58-7.63-8.73-10.66-7.23 13.5-18.96 22.76-24.35 27-3.04 2.4-14.01 10.55-27.38 14.79-18.34 5.81-29.82.69-36.22-4.64-7.69-6.4-12.86-17.29-13.18-27.74-.76-25.3 27.07-39.12 45.97-42.24 10.72-1.77 27.52-1.33 44.01 5.57-.19-1.52-.49-3.08-.92-4.67-4.66-17.17-22.07-32.17-42.32-36.48a8.51 8.51 0 0 1-6.55-10.08 8.51 8.51 0 0 1 10.08-6.55c26.65 5.67 48.83 25.22 55.19 48.66 1.84 6.76 2.15 13.07 1.4 18.89 6.34 4.89 12.25 11.1 17.3 18.94 9.37 14.58 12.67 30.59 11.72 45.65 14.49 9.48 23.99 22.28 27.01 36.59 5.91 27.96-15.45 45.87-16.36 46.62a8.451 8.451 0 0 1-5.39 1.93Zm-44.11-79.82c-11.78 0-23.19 3.52-31.67 8.57-9.65 5.75-15.64 13.45-15.64 20.1 0 3.99 2.05 8.66 5.11 11.63 4.36 4.23 10.85 4.95 15.53 4.81 12.13-.36 25.95-6.8 34.4-16.03 5.05-5.52 10.11-14.47 12.69-25.13-6.59-2.76-13.56-3.95-20.41-3.95Zm-39.27-69.18c-3.37 0-6.42.26-9.02.69-13.43 2.21-32.15 11.42-31.74 24.95.14 4.6 2.41 11.31 7.06 15.18 10.34 8.6 30.9-1.53 42.2-10.43 5.52-4.35 15.75-12.41 20.86-23.56-10.13-5.11-20.76-6.83-29.36-6.83ZM1751.9 1206.35c87.89-23.23 134.23-65.5 123.72-96.24-1.9-5.57-9.11-20.82-45.41-35.27-.07 13.76-1.98 30.81-8.62 49.17-16.29 44.97-51.28 70.83-69.69 82.34Z"
          className="cls-apr44"
        />
        <path
          d="M1742.94 1182.62c29.38-42.13 33.9-77.28 18.14-86.69-2.86-1.7-11.54-5.64-32.46 1.4 5 5.95 10.41 14 14.25 24.34 9.42 25.33 3.79 49.26.07 60.95ZM1767.6 1221.51c36.5 36.14 70.36 46.59 82.32 32.67 2.17-2.52 7.53-10.4 4.16-32.22-6.72 3.91-15.57 7.87-26.41 9.89-26.57 4.95-49.18-4.67-60.07-10.34Z"
          className="cls-apr41"
        />
        <path
          d="M1289.26 259.06c29.05-90.28 17.98-154.77-14.93-162.83-5.96-1.46-23.42-3.71-56.54 20.05 12.05 7.8 25.96 19.07 38.34 35.24 30.34 39.62 33.37 84.89 33.13 107.55Z"
          className="cls-apr44"
        />
        <path
          d="M1263.37 253.59c-20.48-49.52-48.82-73.26-65.95-64.71-3.1 1.55-11.45 6.96-17.03 29.3 8.05-1.04 18.16-1.27 29.4 1.17 27.55 5.98 45.41 24.38 53.58 34.24ZM1311.42 253.8c52.29-11.73 80.52-35.6 75.02-53.93-1-3.32-4.9-12.47-25.96-21.79-.35 8.11-1.85 18.11-6.17 28.77-10.6 26.13-31.78 40.58-42.88 46.95ZM368.41 470.01l-75.15 80.63-135.38-126.19 28.42-30.49L296.95 497.1l46.73-50.13 24.74 23.06ZM422.44 407.02c-21.58 15.39-44.17 20.91-67.77 16.55-23.61-4.35-43.45-17.81-59.54-40.37-16.99-23.82-23.83-48-20.52-72.56 3.31-24.55 16.35-44.95 39.11-61.18 21.5-15.34 43.92-20.7 67.23-16.09 23.32 4.61 43.19 18.44 59.63 41.49 16.89 23.68 23.62 47.68 20.19 71.99-3.42 24.32-16.21 44.37-38.34 60.16Zm-88.83-127.67c-11.91 8.49-18.18 19.7-18.82 33.63-.64 13.93 4.29 28.25 14.78 42.96 10.64 14.92 22.56 24.23 35.76 27.92 13.2 3.69 25.47 1.49 36.82-6.6 11.7-8.34 17.97-19.18 18.82-32.52.85-13.34-4.08-27.5-14.77-42.49-11.14-15.62-23.14-25.4-35.99-29.34-12.85-3.94-25.05-1.79-36.61 6.45ZM617.72 324.48l-102.6 40.27-67.61-172.28 38.81-15.23 55.26 140.81 63.8-25.04 12.35 31.48ZM1772.3 1637.52l-37.42-8.86-2.82-36.48-54.22-12.83-18.77 31.37-37.21-8.81 91.58-139.32 40.72 9.64 18.13 165.29Zm-41.87-73.57-4.24-55.12c-.3-4.11-.07-8.89.69-14.32l-.85-.2c-1.41 4.38-3.35 8.6-5.8 12.66l-28.81 47.74 39.02 9.24ZM1607.61 1800.49 1573.8 1790l18.91-60.94-61.98-19.23-18.91 60.94-33.7-10.46 46.43-149.63 33.7 10.46-18.52 59.68 61.98 19.23 18.52-59.68 33.81 10.49-46.43 149.63ZM1830.49 1742.32l-34.83 16.31-24.87-26.83-50.46 23.63 4.79 36.24-34.63 16.22-14.81-166.06 37.89-17.75 116.91 118.24Zm-78.51-31.63-37.57-40.55c-2.79-3.04-5.57-6.92-8.35-11.65l-.79.37c1.62 4.31 2.72 8.82 3.32 13.53l7.09 55.31 36.31-17.01ZM1608.88 1592.29l-34.6 7.47-13.46-62.37-63.43 13.69 13.46 62.37-34.49 7.44-33.05-153.14 34.49-7.44 13.18 61.09 63.43-13.69-13.18-61.09 34.6-7.47 33.05 153.14ZM1786.68 856.28l-188.02-69.96c-25.45-9.47-34.68-40.74-18.44-62.51l44.86-60.16c16.24-21.77 48.83-21.85 65.17-.15l120.69 160.26c12.7 16.87-4.46 39.89-24.25 32.52Z"
          className="cls-apr41"
        />
        <ellipse
          cx={1613.41}
          cy={701.76}
          className="cls-apr41"
          rx={77.52}
          ry={32.75}
          transform="rotate(-53.29 1613.284 701.77)"
        />
        <path
          d="M1576.8 792.89c-9.31 0-17.9-2.64-25.27-8.15-27.73-20.68-21.65-69.25 14.79-118.1 36.44-48.86 81.25-68.54 108.98-47.86 27.73 20.68 21.65 69.25-14.79 118.1-26.75 35.86-58 56.01-83.71 56.01Zm62.18-125.41c-8.02 5.08-19.26 14.53-30.98 30.25-11.72 15.71-17.57 29.18-20.16 38.32 8.02-5.08 19.26-14.53 30.98-30.25 11.72-15.71 17.57-29.18 20.16-38.32Z"
          className="cls-apr43"
        />
        <circle cx={1670.67} cy={758.33} r={5.46} className="cls-apr45" />
        <circle cx={1731.16} cy={767.64} r={5.46} className="cls-apr45" />
        <circle cx={1678.69} cy={786.6} r={5.46} className="cls-apr45" />
        <circle cx={1698.76} cy={769.06} r={2.73} className="cls-apr45" />
        <circle cx={1727.15} cy={805.01} r={2.73} className="cls-apr45" />
        <circle cx={1764.21} cy={817.87} r={2.73} className="cls-apr45" />
        <circle cx={1787.2} cy={810.24} r={5.23} className="cls-apr45" />
        <circle cx={1776.75} cy={838.07} r={5.23} className="cls-apr45" />
        <circle cx={1799.62} cy={832.84} r={7.19} className="cls-apr45" />
        <circle cx={1747.68} cy={825.65} r={7.19} className="cls-apr45" />
        <circle cx={1694.65} cy={704.5} r={5.46} className="cls-apr45" />
        <circle cx={1711} cy={738.17} r={10.18} className="cls-apr45" />
        <circle cx={1705.17} cy={796.76} r={10.18} className="cls-apr45" />
        <circle cx={1642.08} cy={777.31} r={10.18} className="cls-apr45" />
        <circle cx={1757.86} cy={786.6} r={10.18} className="cls-apr45" />
        <path
          d="M1641.99 677.79c15.32-50.02 8.47-87.85-10.01-94.66-3.35-1.23-13.13-3.68-31.4 7.8 6.82 5.28 14.71 12.69 21.79 22.8 17.37 24.79 19.52 51.04 19.62 64.06Z"
          className="cls-apr45"
        />
        <path
          d="M1634.03 685.22c.86-37.17-11.1-61.74-25.06-62.85-2.53-.2-9.69 0-19.99 11.38 5.68 2.3 12.5 5.85 19.3 11.41 16.65 13.62 23.17 31.17 25.74 40.06ZM1595.63 729.54c-35.73 8.5-62.17 1.99-66.37-11.28-.76-2.41-2.17-9.38 6.51-21.69 3.5 5.02 8.46 10.89 15.36 16.32 16.91 13.31 35.33 16 44.5 16.65Z"
          className="cls-apr44"
        />
        <path
          d="M1587.87 738.09c-16.37 17.28-33.02 23.12-40.01 17.41-1.27-1.04-4.5-4.32-4.16-14.08 3.68 1.48 8.45 2.91 14.12 3.41 13.89 1.22 24.84-3.85 30.04-6.74Z"
          className="cls-apr45"
        />
        <path
          d="M1566.35 682.4c-24.07 6.02-41.97 1.83-44.91-7.1-.53-1.62-1.54-6.32 4.23-14.7 2.4 3.37 5.8 7.29 10.5 10.9 11.52 8.85 23.99 10.53 30.18 10.9ZM1531.22 740.41c-14.31 3.53-24.94 1.01-26.67-4.31-.31-.96-.9-3.76 2.54-8.73 1.42 2 3.43 4.34 6.22 6.5 6.83 5.28 14.23 6.3 17.91 6.54ZM1565.23 618.44c1.52-23.07-5.05-37.99-13.45-38.3-1.52-.06-5.86.26-12.38 7.59 3.37 1.28 7.4 3.29 11.35 6.56 9.7 8 13.17 18.71 14.48 24.15Z"
          className="cls-apr41"
        />
        <path
          d="M1626.49 690.73c-5.44-17.56-14.55-26.77-20.88-24.61-1.15.39-4.27 1.86-7.03 9.16 2.87-.01 6.43.34 10.29 1.64 9.47 3.18 15.09 10.14 17.62 13.81Z"
          className="cls-apr45"
        />
        <path
          d="M1589.75 695.68c-9.23 2.05-15.62.33-16.21-3.03-.11-.61-.22-2.37 2.37-5.46.71 1.28 1.75 2.77 3.29 4.16 3.78 3.41 8.29 4.14 10.56 4.33ZM1622.95 708.79c-6.11-12.96-12.67-18.19-15.66-14.84-.54.61-1.95 2.59-2.1 9.23 1.53-.73 3.5-1.33 5.81-1.24 5.65.22 9.93 4.49 11.95 6.85Z"
          className="cls-apr42"
        />
        <path
          d="M1581.62 672.91c-16.41-.92-26.18-6.74-25.46-12.58.13-1.06.84-4.03 6.73-7.92.52 2.44 1.49 5.4 3.35 8.42 4.55 7.39 11.69 10.71 15.38 12.08Z"
          className="cls-apr45"
        />
        <path
          d="M1577.63 655.16c.22-20.37-5.83-32.31-12.74-31.21-1.25.2-4.79 1.18-9.82 8.63 2.82.57 6.22 1.67 9.61 3.88 8.31 5.4 11.63 14.17 12.95 18.71ZM1590.47 596.14c-.24-15.57-5.1-24.57-10.36-23.6-.95.18-3.64 1-7.33 6.79 2.17.38 4.78 1.15 7.42 2.77 6.46 3.96 9.18 10.6 10.27 14.04Z"
          className="cls-apr44"
        />
        <path
          d="M1518.76 704.67c-15.43 3.46-25.77.71-26.39-4.82-.11-1-.1-3.9 4.5-9 1.02 2.09 2.57 4.54 4.96 6.81 5.85 5.56 13.21 6.72 16.93 7.01Z"
          className="cls-apr45"
        />
        <path
          d="M1509.9 664.46c-14.89 5.32-25.49 3.85-26.78-1.56-.23-.98-.58-3.86 3.37-9.49 1.27 1.95 3.11 4.2 5.75 6.16 6.48 4.81 13.93 5.06 17.66 4.89Z"
          className="cls-apr44"
        />
        <path
          d="M1611.53 715.47c-16.51 5.39-29.06 3.35-31.39-2.74-.42-1.1-1.27-4.33 2.46-10.47 1.78 2.23 4.26 4.8 7.64 7.09 8.28 5.61 16.98 6.17 21.29 6.12Z"
          className="cls-apr45"
        />
        <path
          d="m324.62 1773.99 190.83-139.34c9.58-6.99 9.47-21.32-.21-28.17L372.72 1505.7c-10.24-7.24-24.54-1.55-27.01 10.74l-48.31 240.12c-3.12 15.51 14.45 26.76 27.23 17.43Z"
          className="cls-apr41"
        />
        <ellipse
          cx={434.3}
          cy={1569.09}
          className="cls-apr41"
          rx={39.47}
          ry={95.1}
          transform="rotate(-54.1 434.295 1569.075)"
        />
        <path
          d="M489.72 1659.37c-26.06 0-59.15-12.72-91.51-35.6-23.41-16.55-43.16-36.38-55.6-55.82-22.16-34.61-14.48-57.22-7.93-67.61 4.65-7.37 13.78-16.87 30.93-20.29 27.46-5.47 66.63 7.38 104.79 34.36 23.41 16.55 43.16 36.38 55.6 55.82 22.16 34.61 14.48 57.22 7.93 67.61-4.65 7.37-13.78 16.87-30.93 20.29-4.17.83-8.61 1.24-13.27 1.24ZM381.49 1530.9c4.58 10.59 18.93 30.76 46.74 50.42 14.48 10.24 29.89 18.27 43.39 22.61 6.74 2.17 11.88 3.07 15.49 3.36-4.58-10.59-18.93-30.76-46.74-50.42-14.48-10.24-29.89-18.27-43.39-22.61-6.74-2.17-11.88-3.07-15.49-3.36Z"
          className="cls-apr43"
        />
        <ellipse
          cx={404.58}
          cy={1646.86}
          className="cls-apr45"
          rx={6.73}
          ry={7.12}
          transform="rotate(-19.53 404.64 1647.023)"
        />
        <ellipse
          cx={338.36}
          cy={1683.23}
          className="cls-apr45"
          rx={6.73}
          ry={7.12}
          transform="rotate(-19.53 338.433 1683.4)"
        />
        <ellipse
          cx={407.57}
          cy={1684.88}
          className="cls-apr45"
          rx={6.73}
          ry={7.12}
          transform="rotate(-19.53 407.637 1685.05)"
        />
        <ellipse
          cx={376.62}
          cy={1671.61}
          className="cls-apr45"
          rx={3.37}
          ry={3.56}
          transform="rotate(-19.53 376.685 1671.796)"
        />
        <ellipse
          cx={359.3}
          cy={1727.45}
          className="cls-apr45"
          rx={3.37}
          ry={3.56}
          transform="rotate(-19.53 359.388 1727.628)"
        />
        <ellipse
          cx={321.85}
          cy={1758.52}
          className="cls-apr45"
          rx={3.37}
          ry={3.56}
          transform="rotate(-19.53 321.91 1758.72)"
        />
        <ellipse
          cx={348.95}
          cy={1600.63}
          className="cls-apr45"
          rx={6.73}
          ry={7.12}
          transform="rotate(-19.53 349.028 1600.808)"
        />
        <ellipse
          cx={348.95}
          cy={1638.72}
          className="cls-apr45"
          rx={12.55}
          ry={13.27}
          transform="rotate(-19.53 349.025 1638.887)"
        />
        <ellipse
          cx={381.24}
          cy={1708.28}
          className="cls-apr45"
          rx={12.55}
          ry={13.27}
          transform="rotate(-19.53 381.323 1708.46)"
        />
        <ellipse
          cx={435.33}
          cy={1666.81}
          className="cls-apr45"
          rx={12.55}
          ry={13.27}
          transform="rotate(-19.53 435.397 1666.973)"
        />
        <ellipse
          cx={327.65}
          cy={1724.94}
          className="cls-apr45"
          rx={12.55}
          ry={13.27}
          transform="rotate(-19.53 327.72 1725.14)"
        />
        <path
          d="M392.42 1552.14c-37.98-52.88-46.16-100.16-28.41-115.5 3.22-2.78 13.1-9.53 38.26-3.23a128.587 128.587 0 0 0-14.76 35.49c-9 36.08-.43 67.86 4.91 83.24Z"
          className="cls-apr45"
        />
        <path
          d="M404.41 1557.75c-16.5-43.46-13.43-77.13 1.66-83.96 2.74-1.24 10.81-3.82 27.03 5.5a87.445 87.445 0 0 0-16.74 21.08c-12.87 22.64-12.8 45.89-11.95 57.38ZM465.73 1594.79c43.39-4.11 70.13-22.23 69.26-39.54-.16-3.14-1.51-11.91-16.32-22.98-1.8 7.3-4.88 16.18-10.3 25.31-13.28 22.36-32.69 32.82-42.64 37.22Z"
          className="cls-apr44"
        />
        <path
          d="M477.95 1601.79c25.47 13.89 46.47 14.19 51.87 4.69.98-1.72 3.21-6.87-1.25-18.23-3.48 3.2-8.21 6.77-14.32 9.6-14.97 6.94-29.29 5.29-36.31 3.94Z"
          className="cls-apr45"
        />
        <path
          d="M478.66 1527.66c29.35-2.42 47.55-14.44 47.1-26.13-.08-2.12-.93-8.05-10.86-15.65-1.27 4.92-3.42 10.88-7.15 17-9.14 14.99-22.34 21.89-29.09 24.78ZM542.06 1582.12c17.43-1.5 28.22-8.68 27.93-15.62-.05-1.26-.57-4.78-6.48-9.28-.75 2.92-2.01 6.48-4.22 10.12-5.4 8.93-13.23 13.05-17.23 14.78ZM453.18 1451.86c-11.34-26.59-10.25-46.76-1.02-50.45 1.67-.67 6.64-2 16.97 4.05a46.877 46.877 0 0 0-9.91 12.22c-7.46 13.26-6.85 27.25-6.04 34.18Z"
          className="cls-apr41"
        />
        <path
          d="M415.1 1561.26c-1.28-22.84 5.03-37.29 12.99-37.25 1.44 0 5.54.5 11.67 8.01-3.2 1.12-7.02 2.94-10.79 6-9.23 7.5-12.58 17.92-13.86 23.24Z"
          className="cls-apr45"
        />
        <path
          d="M458.13 1552.57c11.14-1.24 17.54-5.78 16.81-9.98-.13-.76-.74-2.89-4.92-5.5-.25 1.78-.79 3.96-1.92 6.21-2.79 5.51-7.51 8.15-9.96 9.28ZM426.6 1581.14c1.39-17.69 6.52-26.44 11.25-23.68.86.5 3.25 2.28 6.2 10.05-2.01-.25-4.46-.19-6.99.83-6.21 2.5-9.19 9.22-10.45 12.79Z"
          className="cls-apr42"
        />
        <path
          d="M457.67 1522.52c17.91-7.58 26.36-18.3 23.12-24.89-.59-1.2-2.62-4.41-10.81-6.67.44 3.08.6 6.95-.21 11.24-1.98 10.51-8.56 17.24-12.09 20.32Z"
          className="cls-apr45"
        />
        <path
          d="M454.71 1500.03c-8.76-23.91-7-40.37 1.15-41.82 1.48-.26 5.84-.5 14.56 6.29-2.91 1.78-6.23 4.43-9.09 8.37-7.01 9.65-7.04 21.3-6.62 27.16ZM415.72 1435.56c-6.24-18.44-4.58-30.97 1.68-31.9 1.14-.17 4.47-.26 11.01 5.1-2.26 1.3-4.85 3.25-7.11 6.2-5.54 7.22-5.8 16.12-5.59 20.6Z"
          className="cls-apr44"
        />
        <path
          d="M541.02 1535.08c18.65-2.02 29.02-9.36 27.4-16.11-.29-1.22-1.51-4.64-8.78-8.83-.26 2.87-.97 6.37-2.68 9.99-4.19 8.87-11.91 13.14-15.94 14.95Z"
          className="cls-apr45"
        />
        <path
          d="M534.08 1484.2c18.83.38 30.03-5.55 29.2-12.43-.15-1.25-.97-4.78-7.72-9.84-.6 2.8-1.71 6.17-3.84 9.53-5.21 8.23-13.41 11.47-17.64 12.74Z"
          className="cls-apr44"
        />
        <path
          d="M442.13 1584.49c20.65-.18 33.79-7.55 33.85-15.64 0-1.47-.39-5.61-7.12-11.36-1.05 3.33-2.74 7.34-5.55 11.38-6.89 9.89-16.35 13.98-21.18 15.63Z"
          className="cls-apr45"
        />
        <path
          d="m267.59 1124.44 27.63 24.66a10.83 10.83 0 0 0 9.78 2.44l35.98-8.78c8.72-2.13 16.1 6.67 12.48 14.89l-14.92 33.9c-1.44 3.26-1.18 7.02.7 10.06l19.46 31.51c4.72 7.64-1.37 17.37-10.3 16.47l-36.85-3.72c-3.55-.36-7.04 1.05-9.35 3.77l-23.95 28.25c-5.81 6.85-16.95 4.07-18.85-4.71l-7.85-36.19c-.76-3.48-3.18-6.37-6.48-7.73l-34.27-14.05c-8.31-3.41-9.1-14.86-1.35-19.38l31.99-18.65c3.08-1.8 5.08-4.99 5.35-8.55l2.77-36.93c.67-8.95 11.32-13.25 18.02-7.27Z"
          className="cls-apr44"
        />
        <path
          d="m273.93 1149.59 17.59 15.71a6.926 6.926 0 0 0 6.23 1.56l22.91-5.59c5.55-1.35 10.25 4.25 7.95 9.48l-9.5 21.58a6.91 6.91 0 0 0 .44 6.4l12.39 20.06c3 4.86-.87 11.06-6.56 10.49l-23.46-2.37c-2.26-.23-4.49.67-5.95 2.4l-15.25 17.99c-3.7 4.36-10.79 2.59-12-3l-5-23.05a6.886 6.886 0 0 0-4.12-4.92l-21.82-8.95c-5.29-2.17-5.8-9.46-.86-12.34l20.37-11.88a6.893 6.893 0 0 0 3.4-5.44l1.77-23.52c.43-5.7 7.21-8.44 11.47-4.63ZM1730.6 261.92l-7.07 38.32c-.68 3.69.5 7.48 3.15 10.13l27.57 27.55c6.68 6.68 2.81 18.12-6.56 19.36l-38.63 5.12c-3.72.49-6.96 2.78-8.66 6.13l-17.68 34.73c-4.29 8.42-16.37 8.27-20.44-.25l-16.81-35.16a11.4 11.4 0 0 0-8.5-6.34l-38.49-6.08c-9.33-1.47-12.92-13.01-6.07-19.52l28.24-26.85c2.72-2.59 3.99-6.34 3.4-10.05l-6.11-38.49c-1.48-9.33 8.38-16.31 16.69-11.81l34.27 18.56c3.3 1.79 7.27 1.84 10.61.13l34.72-17.7c8.42-4.29 18.1 2.93 16.39 12.22Z"
          className="cls-apr41"
        />
        <path
          d="m1708.84 282.97-4.5 24.4c-.43 2.35.32 4.76 2.01 6.45l17.55 17.54c4.26 4.25 1.79 11.54-4.18 12.33l-24.6 3.26a7.227 7.227 0 0 0-5.51 3.9l-11.26 22.11c-2.73 5.36-10.42 5.27-13.02-.16l-10.7-22.39a7.249 7.249 0 0 0-5.42-4.04l-24.51-3.87c-5.94-.94-8.23-8.28-3.87-12.43l17.98-17.1a7.283 7.283 0 0 0 2.17-6.4l-3.89-24.51c-.94-5.94 5.34-10.39 10.63-7.52l21.82 11.82a7.23 7.23 0 0 0 6.75.08l22.11-11.27c5.36-2.73 11.53 1.87 10.44 7.78Z"
          className="cls-apr45"
        />
        <path
          d="M1087.05 1674.39c-3.94 24.78-28.38 30.29-48.32 34.79-4.78 1.08-57.52 12.43-70.8-11.11-17.41-30.86 30.96-125.36 75.39-106.14 23.74 10.27 48.28 53.82 43.73 82.45ZM842.23 1792.31c21.83 12.37 41.38-3.3 57.33-16.09 3.82-3.07 45.57-37.22 35.45-62.28-13.28-32.86-117.31-53.94-129.99-7.22-6.77 24.96 11.99 71.3 37.21 85.59Z"
          className="cls-apr44"
        />
        <ellipse
          cx={949.53}
          cy={1701.99}
          className="cls-apr41"
          rx={36.49}
          ry={58.13}
          transform="rotate(-25.72 949.394 1701.833)"
        />
        <path
          d="M908.57 383.08c-20.17 8.66-35.66-6.84-48.3-19.5-3.03-3.03-36.05-36.74-24.84-57.56 14.7-27.29 107.19-35.64 113.72 6.21 3.49 22.35-17.27 60.84-40.57 70.85ZM707.03 257.04c1.04 21.93 21.76 29.07 38.68 34.89 4.05 1.4 48.82 16.33 62.62-2.86 18.1-25.16-14.88-111.97-55.36-99.53-21.63 6.65-47.14 42.16-45.94 67.49Z"
          className="cls-apr41"
        />
        <ellipse
          cx={823.94}
          cy={294.24}
          className="cls-apr45"
          rx={50.85}
          ry={31.92}
          transform="rotate(-57.98 823.951 294.245)"
        />
        {children}
      </g>
    </svg>
  );
}
